import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import KeyManagement from "./Components/KeyManagement";
import { useTranslation } from "react-i18next";

/**
 * @namespace KeyManagementPage
 */

const KeyManagementPage = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [{ label: t("title.catalogs") }, { label: t("title.keyManagment") }];
  }, [t]);

  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <KeyManagement />
    </>
  );
};

export default KeyManagementPage;
